export default __webpack_public_path__ + "static/media/Cars_18.336f9ce2.png";